<template>
  <iColumn
    :style-overrides="{paddingTop: 'standard'}"
    :width="85"
    class="left-panel-primary"
    height="fill"
  >
    <iColumn
      height="fill"
      overflow="auto"
      vertical-align="between"
      @mousemove="calculateMouseOverItem"
    >
      <iColumn>
        <iRow
          v-for="menuItem in menuItems"
          :key="menuItem.key"
          :data-section-key="menuItem.key"
          class="clickable panel-menu-item"
          vertical-align="middle"
          width="fill"
          wrap="nowrap"
          @click="changeSection(menuItem.key)"
        >
          <iColumn :align="hasOpenSection ? 'center' : 'left'" gap="extraSmall">
            <iColumn :class="{'icon': true, 'active': hasOpenSection && isActiveSection(menuItem.key)}" width="hug">
              <iIcon
                :icon="menuItem.icon"
                :label="getItemLabel(menuItem.title)"
                :name="menuItem.icon"
                size="large"
                variant="primary"
              />
            </iColumn>
            <iText font-size="verySmall">
              {{ getIconLabel(menuItem.title) }}
            </iText>
          </iColumn>
        </iRow>
      </iColumn>
    </iColumn>
  </iColumn>
</template>

<script>
import { mapState } from "pinia";
import { useStagingFrameStore } from "~/stores/staging-frame-store";

export default {
  name: "Create",
  props: {
    activeSection: {
      type: String,
      default: "publications",
    },
  },
  emits: ["click:menu-item", "hover:menu-item", "select:section"],
  computed: {
    ...mapState(useStagingFrameStore, [
      "leftPanelTwoCollapsed",
    ]),
    hasOpenSection() {
      return Boolean(this.activeSection) || this.leftPanelTwoCollapsed;
    },
    menuItems() {
      const items = [];

      items.push({
        title: "Publications",
        icon: "document",
        key: "publications",
      });

      items.push({
        title: "Apps",
        icon: "tdesign:app",
        key: "apps",
      });

      return items;
    },
  },
  methods: {
    getIconLabel(menuItemTitle) {
      if (!this.hasOpenSection) {
        return "";
      }
      return menuItemTitle;
    },
    getItemLabel(menuItemTitle) {
      if (this.hasOpenSection) {
        return "";
      }
      return menuItemTitle;
    },
    isActiveSection(itemKey) {
      return this.activeSection === itemKey;
    },
    calculateMouseOverItem(event) {
      // get closest element with class clickable
      let target = event.target.closest(".panel-menu-item");
      if (!target) {
        // get the closest to the mouse
        const clickableElements = document.querySelectorAll(".panel-menu-item");
        const distances = Array.from(clickableElements).map(element => {
          const rect = element.getBoundingClientRect();
          return {
            element,
            distance: Math.abs(rect.top - event.clientY),
          };
        });

        distances.sort((a, b) => a.distance - b.distance);
        if (distances[0].distance < 15) {
          target = distances[0].element;
        } else {
          return;
        }
      }

      this.$emit("hover:menu-item", target.dataset.sectionKey);
    },
    changeSection(menuItemKey) {
      if (this.activeSection === menuItemKey) {
        return;
      }
      this.$emit("select:section", menuItemKey);
    },
  },
  styleGuide: () => ({
    "panelContentPadding": { "size.spacing": "small" },
    "itemIconPadding": { "size.spacing": "extraSmall" },
    "activeItemBorderColor": { "color.border": "striking" },
    "activeItemBorderRadius": { "size.borderRadius": "large" },
    "rightBorderColor": { "color.border": "dark" },
  }),
};
</script>

<style lang="scss" scoped>

.left-panel-primary {
  border-right: 1px solid v-bind("$getStyles.rightBorderColor");
  height: calc(100vh - 67px) !important;
}

.clickable {
  cursor: pointer;
}

.icon {
  padding: v-bind("$getStyles.itemIconPadding");

  &.active {
    background-color: v-bind("$getStyles.activeItemBorderColor");
    border-radius: v-bind("$getStyles.activeItemBorderRadius");

    :deep(svg) {
      fill: black;
    }
  }
}
</style>
